import React from 'react'
import SEO from "../component/SEO";
import successImage from "../images/yo.png"

const Success = () => {
  return (
    <div className='flex flex-col my-36 items-center justify-center'>
    <SEO title="Payment Successful - K Bakery" description="Your order has been placed successfully." />
    <h1 className="text-3xl font-bold text-green-600 mb-4">Payment Successful!</h1>
    <img src={successImage} style={{ width: '500px', height: '350px' }} alt="Order success"/>
  </div>
  )
}

export default Success